<!-- SELECTED PRODUCTS FOOTER TEMPLATE -->
<ng-template #selectedProductsFooter let-viewModel="viewModel">
  <ion-card
    *ngIf="viewModel?.numberOfProductsSelected >= 1"
    id="product-selection-footer"
    data-cy="selected-products-footer"
    class="selected-products-footer"
  >
    <ion-grid
      *ngIf="
        platformService.platformType === platformService.platformEnum.desktop ||
        platformService.platformType === platformService.platformEnum.tablet
      "
      [fixed]="true"
    >
      <ion-row>
        <ion-col class="deselect-all-col" size="4">
          <ion-label
            [hidden]="viewModel?.numberOfProductsSelected < 2"
            data-cy="deselect-all"
            class="deselect-all"
            (click)="deselectAllProducts()"
          >
            {{ 'i18n.lists.deselectAll' | translate }}
          </ion-label>
        </ion-col>
        <ion-col size="4">
          <ion-text data-cy="num-selected-products-text">
            {{ viewModel?.numberOfProductsSelected - 0 }}&nbsp;{{
              (viewModel?.numberOfProductsSelected - 0 > 1
                ? 'i18n.lists.products'
                : 'i18n.lists.product'
              ) | translate
            }}&nbsp;{{ 'i18n.lists.selected' | translate }}
          </ion-text>
        </ion-col>
        <ion-col class="add-to-inventory-col" size="4">
          <ion-button
            (click)="addToInventory(viewModel)"
            data-cy="add-to-inventory"
            >{{ 'i18n.inventory.addToInventoryTitle' | translate }}
            <ion-icon name="chevron-forward-outline"></ion-icon
          ></ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid
      *ngIf="
        platformService.platformType === platformService.platformEnum.mobile
      "
      [fixed]="true"
    >
      <ion-row>
        <ion-col class="deselect-all-col" size="6">
          <ion-label
            [hidden]="viewModel?.numberOfProductsSelected < 2"
            data-cy="deselect-all"
            class="deselect-all"
            (click)="deselectAllProducts()"
          >
            {{ 'i18n.lists.deselectAll' | translate }}
          </ion-label>
        </ion-col>
        <ion-col class="add-to-inventory-col" size="6">
          <ion-button
            (click)="addToInventory(viewModel)"
            data-cy="add-to-inventory"
            >{{ viewModel?.numberOfProductsSelected - 0 }}&nbsp;{{
              (viewModel?.numberOfProductsSelected - 0 > 1
                ? 'i18n.lists.products'
                : 'i18n.lists.product'
              ) | translate
            }}&nbsp;{{ 'i18n.lists.selected' | translate }}
            <ion-icon name="chevron-forward-outline"></ion-icon
          ></ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
</ng-template>

<!-- NO PRODUCTS FOUND -->
<ng-template #noProductsFound>
  <div
    data-cy="add-to-inventory-no-products-found-section"
    class="no-products-found-section"
  >
    <span data-cy="add-to-inventory-no-products-found-text">
      {{ 'i18n.search.noSearchResults.noResultFound' | translate }}
    </span>
    <span data-cy="add-to-inventory-no-products-found-subtext">
      {{ 'i18n.search.noSearchResults.pleaseTryAgain' | translate }}
    </span>
  </div>
</ng-template>

<!-- Header Desktop/Tablet -->
<ng-template #desktopTabletProductHeader let-viewModel="viewModel">
  <ion-grid [fixed]="true" class="desktop-tablet-product-grid">
    <ion-row
      class="header-row"
      *ngIf="
        platformService.platformType === platformService.platformEnum.desktop
      "
    >
      <ion-col size="10" class="title">
        {{ 'i18n.inventory.addToInventoryTitle' | translate }}
      </ion-col>
      <ion-col size="1.25" offset="0.75"
        ><ion-button
          (click)="back()"
          class="usf-fill-green-dsktp-tblt-modal-button back-btn"
          data-cy="add-to-inventory-back-buttton"
        >
          {{ 'i18n.common.back' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row class="sub-header-row">
      <ion-col size="10"
        ><span class="past-purchases-title">{{
          'i18n.inventory.pastPurchasesTitle'
            | translate
              : {
                  pastPurchaseDays: viewModel?.pastPurchaseDays
                }
        }}</span>
        <span class="past-purchases-results"
          >&nbsp;({{ viewModel?.products?.length }}&nbsp;{{
            'i18n.common.results' | translate
          }})</span
        >
      </ion-col>
      <ion-col
        size="2"
        *ngIf="
          platformService.platformType === platformService.platformEnum.tablet
        "
        ><ion-button
          (click)="back()"
          class="usf-fill-green-dsktp-tblt-modal-button back-btn"
          data-cy="add-to-inventory-back-buttton"
        >
          {{ 'i18n.common.back' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row class="search-row">
      <ion-col size="4">
        <ion-searchbar
          id="add-inventory-search"
          data-cy="inventory-add-inventory-searchbar"
          class="search"
          mode="md"
          placeholder="{{ 'i18n.inventory.searchRecentPurchase' | translate }}"
          [(ngModel)]="searchKey"
          (ionClear)="resetSearch()"
          (ionInput)="onSearchChange()"
        >
        </ion-searchbar>
      </ion-col>
      <ion-col offset="6" size="2">
        <ion-button
          class="usf-outline-green-button select-all-products-button"
          (click)="selectAllProducts(viewModel.products)"
          data-cy="add-to-inventory-select-all"
        >
          {{ 'i18n.inventory.selectAll' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-template>

<!-- Header Mobile -->
<ng-template #mobileProductHeader let-viewModel="viewModel">
  <ion-grid [fixed]="true" class="mobile-product-grid">
    <ion-row class="sub-header-row">
      <ion-col size="12"
        ><span class="past-purchases-title">{{
          'i18n.inventory.pastPurchasesTitle'
            | translate
              : {
                  pastPurchaseDays: viewModel?.pastPurchaseDays
                }
        }}</span>
        <span class="past-purchases-results"
          >&nbsp;({{ viewModel?.products?.length }}&nbsp;{{
            'i18n.common.results' | translate
          }})</span
        >
      </ion-col>
    </ion-row>
    <ion-row class="search-row">
      <ion-col size="12">
        <ion-searchbar
          id="add-inventory-search"
          data-cy="inventory-add-inventory-searchbar"
          class="search"
          mode="md"
          placeholder="{{ 'i18n.inventory.searchRecentPurchase' | translate }}"
          [(ngModel)]="searchKey"
          (ionClear)="resetSearch()"
          (ionInput)="onSearchChange()"
        >
        </ion-searchbar>
      </ion-col>
    </ion-row>
    <ion-row class="mobile-buttons-row">
      <ion-col size="4"
        ><ion-button
          (click)="back()"
          class="usf-fill-green-dsktp-tblt-modal-button back-btn"
          data-cy="add-to-inventory-back-buttton"
        >
          {{ 'i18n.common.back' | translate }}
        </ion-button>
      </ion-col>
      <ion-col offset="3" size="5">
        <ion-button
          class="usf-outline-green-button select-all-products-button"
          (click)="selectAllProducts(viewModel.products)"
          data-cy="add-to-inventory-select-all"
        >
          {{ 'i18n.inventory.selectAll' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-template>

<ion-content
  *ngIf="viewModel$ | async as viewModel"
  id="add-to-inventory"
  class="gray-content-bg"
  scroll-y="false"
>
  <!-- Desktop/Tablet Header -->
  <ng-container
    *ngIf="platformService.platformType !== platformService.platformEnum.mobile"
    [ngTemplateOutlet]="desktopTabletProductHeader"
    [ngTemplateOutletContext]="{ viewModel: viewModel }"
  ></ng-container>

  <!-- Mobile Header -->
  <ng-container
    *ngIf="platformService.platformType === platformService.platformEnum.mobile"
    [ngTemplateOutlet]="mobileProductHeader"
    [ngTemplateOutletContext]="{ viewModel: viewModel }"
  ></ng-container>

  <cdk-virtual-scroll-viewport
    data-cy="add-to-inventory-scroll"
    class="cdk-scroll"
    orientation="vertical"
    appCustomVs
    [itemHeights]="viewModel?.itemHeights"
    [indexOffset]="viewModel?.indexOffset"
  >
    <!-- Desktop Cards-->
    <ion-grid
      *ngIf="
        platformService.platformType === platformService.platformEnum.desktop
      "
      [fixed]="true"
      class="product-grid"
    >
      <ion-row
        *cdkVirtualFor="
          let product of viewModel?.products;
          let i = index;
          trackBy: trackItem
        "
      >
        <ion-col>
          <app-usf-product-card-desktop
            [vm]="{
              mode: mode,
              product: product,
              isSelected: product.isSelected
            }"
          >
            <app-usf-checkbox
              [isSelected]="product.isSelected"
              (selectEmitter)="selectProduct(product)"
            ></app-usf-checkbox>
          </app-usf-product-card-desktop>
        </ion-col>
      </ion-row>
      <!-- No Results -->
      <ion-row *ngIf="viewModel.products?.length === 0">
        <ion-col size-xl="9" size-lg="9" size-md="9" size-sm="12" size-xs="12">
          <ng-container [ngTemplateOutlet]="noProductsFound"></ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- Touch Cards-->
    <ion-grid
      *ngIf="
        platformService.platformType === platformService.platformEnum.tablet ||
        platformService.platformType === platformService.platformEnum.mobile
      "
      [fixed]="true"
      class="product-grid"
    >
      <ion-row
        *cdkVirtualFor="
          let product of viewModel?.products;
          let i = index;
          trackBy: trackItem
        "
      >
        <ion-col size="12">
          <app-usf-product-card-touch
            [vm]="{
              mode: mode,
              product: product,
              isSelected: product.isSelected
            }"
          >
            <app-usf-checkbox
              [isSelected]="product.isSelected"
              (selectEmitter)="selectProduct(product)"
            ></app-usf-checkbox>
          </app-usf-product-card-touch>
        </ion-col>
      </ion-row>
      <!-- No Results -->
      <ion-row *ngIf="viewModel.products?.length === 0">
        <ion-col size-xl="9" size-lg="9" size-md="9" size-sm="12" size-xs="12">
          <ng-container [ngTemplateOutlet]="noProductsFound"></ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>
  </cdk-virtual-scroll-viewport>
  <!-- Selected Products Footer -->
  <ng-container
    [ngTemplateOutlet]="selectedProductsFooter"
    [ngTemplateOutletContext]="{ viewModel: viewModel }"
  ></ng-container>
</ion-content>
